import { FormLabel, FormSectionHeader, Select } from "@/components";
import {
  Card,
  CardContent,
} from "@/components/ui";
import { images } from "@/assets";
import {
  MapPin,
} from "lucide-react";
import { BudgetExpenseChart } from "../BudgetExpenseChart";
import { BudgetIncomeChart } from "../BudgetIncomeChart";
import useOwnerHeaderCard from "./useOwnerDashboard";
import { NewsLetterCard } from "../NewsLetterCard";
import { CommunitySnapshot } from "./CommunitySnapshot";
import { FinancialOverview } from "./FinancialOverview";
import { ImportantAlerts } from "./ImportantAlerts";
import { ReportSection } from "../ReportSection";

const OwnerHeaderCard = () => {
  const {
    loggedInUserData,
    communityDetail,
    onPropertyChange,
    propertyList,
    currentFinanceYear,
    communityLocation,
    propertyData,
    snapshotCards,
    alertCards,
    propertyKey
  } = useOwnerHeaderCard();

  return (
    <div className="grid grid-cols-1 gap-[20px] xl:grid-cols-4">
      <div className="grid grid-cols-1 gap-[20px] xl:col-span-3">
        <Card className="overflow-hidden p-0 shadow-none">
          <CardContent className="p-0">
            <div className="relative min-h-[250px] overflow-hidden lg:min-h-[280px]">
              <img
                src={images.owner_dashboard}
                alt=""
                className="absolute inset-0 h-full w-full object-cover object-center"
              />
              <div className="relative z-10 flex min-h-[250px] flex-col justify-center gap-3 p-8 text-white lg:min-h-[280px] lg:p-12">
                <span className="text-[20px] font-[400]">
                  Hello, {loggedInUserData?.fullName || ""}
                </span>
                <h1 className="text-[22px] font-[700] lg:text-[28px]">
                  {communityDetail?.communityName || ""}
                </h1>
                {propertyList?.data?.length == 1 ? (
                  <div className="flex flex-col gap-1">
                    <span className="text-[15px] font-[500] text-white">
                      {propertyData?.name || propertyList?.data?.[0]?.name || ""}
                    </span>
                  </div>
                ) :
                  <div className="relative w-[200px]">
                    <FormLabel className="text-gray-900">Select Property</FormLabel>
                    <Select
                      key={propertyKey}
                      options={propertyList?.data?.map((data: any) => ({
                        label: data?.name,
                        value: data?.propertyId?.toString()
                      }))}
                      value={propertyData?.propertyId?.toString()}
                      onChange={onPropertyChange}
                    />
                  </div>
                }
                {communityLocation &&
                  <span className="flex flex-row items-center gap-2 text-[15px] font-[500] text-white">
                    <MapPin className="h-5 w-5" />
                    {communityLocation}
                  </span>}
              </div>
            </div>
            <CommunitySnapshot snapshotCards={snapshotCards} />
          </CardContent>
        </Card>

        <ReportSection variant="owner" />
        <FinancialOverview />
        <Card className="shadow-none">
          <CardContent>
            <FormSectionHeader className="text-[18px] font-[500] text-gray-900">
              Financial Trends (Year: {currentFinanceYear})
            </FormSectionHeader>
            <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
              <Card className="p-0 shadow-none">
                <CardContent className="p-3">
                  <BudgetExpenseChart />
                </CardContent>
              </Card>
              <Card className="p-0 shadow-none">
                <CardContent className="p-3">
                  <BudgetIncomeChart />
                </CardContent>
              </Card>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid h-fit grid-cols-1 gap-[20px]">
        <ImportantAlerts alertCards={alertCards} />
        <NewsLetterCard />
      </div>
    </div>
  );
};

export default OwnerHeaderCard;
